// Slug primitive shared by kanban_status and state — strict subset of ClickHouse VALID_JSON_PATH_REGEX so analytics paths never need quoting.

import { z } from 'zod';

export const SLUG_REGEX = /^[a-z][a-z0-9_]{0,49}$/;

export const slugSchema = z
  .string()
  .regex(
    SLUG_REGEX,
    'slug must be lowercase, start with a letter, contain only [a-z0-9_], and be 1–50 characters',
  );

const INVISIBLE_NAME_CHARS = /[\s\p{Default_Ignorable_Code_Point}]/gu;

export function visibleLength(s: string): number {
  return s.replace(INVISIBLE_NAME_CHARS, '').length;
}
